import React from 'react'

import Image3withBG from "../../assets/borrower-page/Image3withBG.svg";
import { Box, Button, Container, Grid, InputLabel, Stack, TextField, Typography, } from "@mui/material";
import Background from "../../assets/borrower-page/Background.svg";
import stepProgress from "../../assets/borrower-page/stepProgress.png";

export default function PreApproval() {
    return (
        <Grid container justifyContent="center" spacing={0}>
            <Grid item xs={11} md={11} lg={11} mt={0} mb={0} ml={0} mr={0}

            >
                <div>


                    <Box>

                        <Grid
                            container
                            minHeight="50vh"
                            alignItems="top"
                        //  pt={{ xs: 4, md: 1 }}
                        >
                            <Grid
                                item
                                xs={12}
                                md={5}
                                textAlign={{ xs: "center", md: "start" }}
                                px={{ xs: 2 }}  //padding x-axis left

                            >
                                <Typography
                                    variant="h2"
                                    component="h1"
                                    mb={2} mt={0}
                                    fontWeight={"bold"}
                                    lineHeight={"50px"}
                                >
                                    {`Get Quick Pre- Approval`}
                                </Typography>
                                <Typography variant="body1" mb={1}>
                                    {`Our streamlined verification process simplifies the submission and review of essential documents, ensuring accuracy and a smooth mortgage journey. Experience efficiency at its best.`}
                                </Typography>

                            </Grid>
                            <Grid item md={2}></Grid>
                            {/* Intro Image */}
                            {/* Background Image with Overlay */}
                            <Grid item xs={12} md={5}>
                                <Box position="relative" my={{ md: "none", xs: 2 }}>
                                    {/* Background Image */}
                                    <img src={Background} width="100%" height="100%" />

                                    {/* Overlay Image */}
                                    <img
                                        src={Image3withBG} width={"100%"}
                                        //  width="515px"
                                        // height="363px"
                                        style={{
                                            position: "absolute", top: 0, left: 0,

                                            bottom: 0, // Align to the bottom of the parent container
                                            left: "50%", // Center horizontally
                                            transform: "translateX(-50%)" // Adjust horizontally to center

                                        }}
                                        alt="Overlay Image"


                                    />
                                </Box>
                            </Grid>
                        </Grid>

                    </Box>

                </div>
            </Grid>
        </Grid>
    )
}
